module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.ttf?6a2ddad1092a0a1c326b6d0e738e682b";